import React, {useState} from 'react';
import {Col, Row} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import {getUserDoubleCheck} from "../../api/apiClient";

const InputUserId = ({
                       propValue = '',
                       propOnChange = null,
                     }) => {
  const [error, setError] = useState();


  const inspectUserIdDoubleCheck = () => {
    const userIdRegex = /^[A-Za-z0-9+]{5,}$/;
    if (userIdRegex.test(propValue)) {
      setError('');

      getUserDoubleCheck(propValue).then((res) => {
        if (res.data.data.isExist === true) {
          setError('사용중인 ID 입니다.');
        } else {
          setError('사용 가능한 ID 입니다.');
        }
      });

    } else {
      setError("5~20자리 이내 (영문 대/소문자, 숫자 가능)");
    }
  };

  return (
      <>
        <Form.Group as={Row} controlId="formUserId">
          <Form.Label column md={3} className={'label text-end fw-bold'}>
            <span className={"text-danger"}>* </span>사용자 ID
          </Form.Label>
          <Col md={7} className={''}>
            <Form.Control
                type='text'
                className={'input text-white'}
                onChange={propOnChange}
                required
                // defaultValue={propValue || ''}
                value={propValue || ''}
            />
          </Col>
          <Col md={2}>
            <Button className={"btn btn-secondary w-100"}
                    onClick={inspectUserIdDoubleCheck}
            >확인</Button>
          </Col>
        </Form.Group>

        {error !== "" ? (
            <Col md={12} className={"error text-center text-danger"}>
              {error}
            </Col>
        ) : ("")}
      </>
  );
};

export default InputUserId;